// extracted by mini-css-extract-plugin
export default {"sort":"VC-z","sortSelect":"WC-z","disabled":"XC-z"};